/*
 * Copyright (c) 2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */


import {ElementRef, Injectable, NgZone, Renderer2} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
export class DragDispatcher {
private _listeners: Function[];

    // Will be listening to Drag events on the following element
    handleRef: ElementRef;

    // Extra element to be used for tracking drag movements.
    handleTrackerRef: ElementRef;
private _onDragStart: Subject<void> = new Subject<void>();
private _onDragMove: Subject<void> = new Subject<void>();
private _onDragEnd: Subject<void> = new Subject<void>();
/**
 * @return {?}
 */
get onDragStart(): Observable<any> {
        return this._onDragStart;
    }
/**
 * @return {?}
 */
get onDragMove(): Observable<any> {
        return this._onDragMove;
    }
/**
 * @return {?}
 */
get onDragEnd(): Observable<any> {
        return this._onDragEnd;
    }
/**
 * @param {?} _ngZone
 * @param {?} _renderer
 */
constructor(private _ngZone: NgZone,
private _renderer: Renderer2) {}
/**
 * @return {?}
 */
addDragListener() {
        const /** @type {?} */ handleEl = this.handleRef.nativeElement;
        this._listeners = [
            this.customDragEvent(handleEl, "mousedown", "mousemove", "mouseup"),
            this.customDragEvent(handleEl, "touchstart", "touchmove", "touchend")
        ];
    }
/**
 * @param {?} element
 * @param {?} startOnEvent
 * @param {?} moveOnEvent
 * @param {?} endOnEvent
 * @return {?}
 */
customDragEvent(element: HTMLElement, startOnEvent: string, moveOnEvent: string, endOnEvent: string): Function {
        let /** @type {?} */ dragMoveListener: any;
        let /** @type {?} */ dragEndListener: any;

        return this._renderer.listen(element, startOnEvent, (startEvent: any) => {
            this.notifyDragStart(startEvent);

            dragMoveListener = this._ngZone.runOutsideAngular(() => {
                return this._renderer.listen("document", moveOnEvent, (moveEvent: any) => {
                    this.notifyDragMove(moveEvent);
                });
            });

            dragEndListener = this._renderer.listen("document", endOnEvent, (endEvent: any) => {
                // Unsubscribing from mouseMoveListener
                dragMoveListener();
                this.notifyDragEnd(endEvent);
                // Unsubscribing from itself
                dragEndListener();
            });
        });
    }
/**
 * @param {?} event
 * @return {?}
 */
notifyDragStart(event: any) {
        return this._onDragStart.next(event);
    }
/**
 * @param {?} event
 * @return {?}
 */
notifyDragMove(event: any) {
        return this._onDragMove.next(event);
    }
/**
 * @param {?} event
 * @return {?}
 */
notifyDragEnd(event: any) {
        return this._onDragEnd.next(event);
    }
/**
 * @return {?}
 */
destroy() {
        this._listeners.map(event => event());
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgZone, },
{type: Renderer2, },
];
}

function DragDispatcher_tsickle_Closure_declarations() {
/** @type {?} */
DragDispatcher.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DragDispatcher.ctorParameters;
/** @type {?} */
DragDispatcher.prototype._listeners;
/** @type {?} */
DragDispatcher.prototype.handleRef;
/** @type {?} */
DragDispatcher.prototype.handleTrackerRef;
/** @type {?} */
DragDispatcher.prototype._onDragStart;
/** @type {?} */
DragDispatcher.prototype._onDragMove;
/** @type {?} */
DragDispatcher.prototype._onDragEnd;
/** @type {?} */
DragDispatcher.prototype._ngZone;
/** @type {?} */
DragDispatcher.prototype._renderer;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
